<template>
  <img :src="`${publicPath}img/flags/${iso}.svg`" :alt="`${alt || iso} flag`" />
</template>

<script>
export default {
  props: {
    iso: {
      type: [Boolean, String],
      default: "",
    },
    alt: {
      type: [String],
      default: "",
    },
  },
  data() {
    return {
      publicPath: window.data_vis_uri || process.env.BASE_URL,
    };
  },
};
</script>
